// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import { Fragment } from 'react'

import loadable from '@loadable/component'
import { Container } from '../helpers/react'
import { UswitchHeader, MoneyHeader } from './header'

const Unsubscribe = loadable(() => import('./unsubscribe/index'))
const LeadPosterForm = loadable(() => import('./lead-poster-form'))
const USwitchEligibilityBanner = loadable(() => import('./eligibility-banner-uswitch'))
const ProvidersList = loadable(() => import('./providers-list-wrapper'))
const CreditCardCalculator = loadable(() => import('./calculators/credit-card-calculator'))
const UswitchCreditCardCalculator = loadable(
  () => import('./calculators/compounds/uswitch-credit-card-calculator'),
)
const MortgageAffordabilityCalculator = loadable(
  () => import('./calculators/mortgage-affordability-calculator'),
)
const PensionsCalculator = loadable(() => import('./calculators/pensions-calculator'))
const PensionsDrawdownCalculator = loadable(
  () => import('./calculators/pensions-drawdown-calculator'),
)
const PensionsPayoutCalculator = loadable(() => import('./calculators/pensions-payout-calculator'))
const SavingsCalculator = loadable(() => import('./calculators/savings-calculator'))

const PoweredByMojoTrustpilot = loadable(() => import('./powered-by-mojo-trustpilot'))

const MortgageCalculator = loadable(() => import('./calculators/mortgage-calculator'))
const StampDutyCalculator = loadable(() => import('./calculators/stamp-duty-calculator'))

const SMEform = loadable(() => import('./sme-form'))
const SMEproviderForm = loadable(() => import('./sme-zempler-form'))
const JsonLDScript = loadable(() => import('./json-ld-script'))
const ResultsCard = loadable(() => import('./results-card/results-card'))

const IwocaForm = loadable(() => import('./iwoca-form'))

const COMPONENTS = {
  CreditCardCalculator,
  IwocaForm,
  JsonLDScript,
  LeadPosterForm,
  MoneyHeader,
  MortgageAffordabilityCalculator,
  MortgageCalculator,
  PensionsCalculator,
  PensionsDrawdownCalculator,
  PensionsPayoutCalculator,
  PoweredByMojoTrustpilot,
  ProvidersList,
  ResultsCard,
  SavingsCalculator,
  SMEform,
  SMEproviderForm,
  StampDutyCalculator,
  USwitchEligibilityBanner,
  Unsubscribe,
  UswitchCreditCardCalculator,
  UswitchHeader,
}

const Component = ({ component, container = false, options = {}, ...rest }) => {
  const C = COMPONENTS[component] || Fragment
  /* eslint-disable camelcase */
  const dataClickTracking = {
    component_category: 'component',
    component_id: rest.sys?.id,
    component_name: component,
    contentful_name: rest.name,
    contentful_variant: component,
  }
  return (
    <Choose>
      <When condition={container}>
        <Container>
          <C {...options} sys={rest.sys} dataClickTracking={dataClickTracking} {...rest} />
        </Container>
      </When>

      <Otherwise>
        <C {...options} sys={rest.sys} {...rest} />
      </Otherwise>
    </Choose>
  )
}

export default Component
